<template>
    <div class="p-3">
        <b-card no-body class="mb-2">
            <div class="row">
                <div class="col-12 d-flex justify-content-center mb-4">
                    <b-avatar :src="form.foto" size="120px"></b-avatar>
                </div>
                <input-text class="col-12 col-md-6" label="Nome" v-model="form.nome" readonly/>
                <input-select :class="`col-12 col-md-3`" label="Titulação" :options="options.titulacao" v-model="form.titulacao" disabled />
                <input-select :class="`col-12 col-md-3`" label="Nacionalidade" :options="options.nacionalidade" v-model="form.nacionalidade" disabled/>
                <input-mask :mask="['###.###.###-##']" class="col-12 col-md-3" label="CPF" v-if="form.nacionalidade != 'Estrangeira'" v-model="form.cpf" readonly type="cpf"/>
                <input-text class="col-12 col-md-3" label="Passaporte" v-model="form.passaporte" v-if="form.nacionalidade == 'Estrangeira'" readonly />
                <input-select class="col-12 col-md-3" label="UF" :options="options.uf" v-model="form.endereco.uf" v-if="form.nacionalidade != 'Estrangeira'" disabled />
                <input-select class="col-12 col-md-6" label="Cidade" :options="options.cidades" v-model="form.endereco.cidade" v-if="form.nacionalidade != 'Estrangeira'" disabled  />
                <input-mask :mask="['(##) ####-####', '(##) #####-####']" :class="`col-12 col-md-3`" label="Celular" v-model="form.celular" readonly/>
                <input-text :class="`col-12 col-md-${form.nacionalidade == 'Estrangeira' ? '6' : '9'}`" label="Email" v-model="form.email" readonly />
            </div>
        </b-card>
        <b-card no-body>
            <div class="row">
                <div class="col-12 h5">Horas alocadas</div>
                <input-text class="col-12 col-md-3" :min="1998" :label="'Ano inicial'" v-model="anoInicio"/>
                <input-select class="col-12 col-md-3" label="Mês inicial" :options="options.meses" v-model="mesInicio"/>
                <input-text class="col-12 col-md-3" :min="1998" :label="'Ano final'" v-model="anoFinal"/>
                <input-select class="col-12 col-md-3" label="Mês final" :options="options.meses" v-model="mesFinal">
                    <template #append>
                        <b-button class="ml-2" @click="buscarHoras">
                            <i class="fas fa-search"></i>
                            Buscar
                        </b-button>
                    </template>
                </input-select>
                <vue-perfect-scrollbar>
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <b-tr>
                                <b-th rowspan="2">Cód. Projeto</b-th>
                                <b-th rowspan="2">Projeto</b-th>
                                <b-th rowspan="2">#</b-th>
                                <template v-for="ano,i in anos">
                                    <b-th :colspan="ano.meses.length" :key="`ano_${i}`" class="text-center">{{ano.ano}}</b-th>
                                </template>
                            </b-tr>
                            <b-tr>
                                <template v-for="ano,j in anos">
                                    <template v-for="mes,i in ano.meses">
                                        <b-th class="text-center" :key="`thead_mes${i}${j}`">{{mes.nomeMes}}</b-th>
                                    </template>
                                </template>
                            </b-tr>
                        </b-thead>
                
                        <b-tbody >
                            <template v-for="dado,i in dados">                                
                                <b-tr :key="`linha${i}_1`">
                                    <b-td rowspan="2">{{dado.codigoProjeto}}</b-td>
                                    <b-td rowspan="2">{{dado.projeto}}</b-td>
                                    <b-td>Planejado</b-td>
                                    <b-td class="text-center" :class="horas.horasPrevistas > 176 ? 'text-red-500 h6' : ''" v-for="horas,i in dado.alocacoes" :key="`horas_1_${i}`">
                                        {{horas.horasPrevistas}}
                                    </b-td>
                                </b-tr>
                                <b-tr :key="`linha${i}_2`">
                                    <b-td>Realizado</b-td>
                                    <b-td class="text-center" :class="horas.horasRealizadas > 176 ? 'text-red-500 h6' : ''" v-for="horas,i in dado.alocacoes" :key="`horas_2_${i}`">
                                        {{horas.horasRealizadas}}
                                    </b-td>
                                </b-tr>

                            </template>
                        </b-tbody>
                        <b-tfoot>
                            <b-tr variant="warning">
                                <b-td colspan="3">Total planejado</b-td>
                                <b-td class="text-center" :class="horas > 176 ? 'bg-red-200 h6' : ''"  v-for="horas,i in total.planejado" :key="`total_1_${i}`">
                                        {{horas}}
                                    </b-td>
                            </b-tr>
                            <b-tr variant="warning">
                                <b-td colspan="3">Total realizado</b-td>
                                <b-td class="text-center" :class="horas > 176 ? 'bg-red-200 h6' : ''" v-for="horas,i in total.realizado" :key="`total_1_${i}`">
                                        {{horas}}
                                    </b-td>
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </vue-perfect-scrollbar>
            </div>
        </b-card>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputMask from "@/components/inputs/InputMask";

import PessoaService from "@/common/services/pessoa/pessoa.service";
import InfosService from "@/common/services/infos/infos.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import { START_LOADING, STOP_LOADING } from "@/store/Store";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import helpers from "@/common/utils/helpers";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";

export default {
    mixins : [AlertasMixin],
    props: ["id"],
    components: {
        InputText,
        InputSelect,
        InputMask,
        VuePerfectScrollbar,
    },
    data : () => ({
        form: {
            nome: '',
            titulacao: '',
            nacionalidade: '',
            cpf: '',
            passaporte: '',
            endereco: {
                uf: '',
                cidade: ''
            },
            celular: '',
            email: ''
        },
        options: {
            nacionalidade: helpers.Nacionalidade,
            titulacao: helpers.Titulacao,
            uf: helpers.UF,
            cidades : [],
            meses : []
        },
        dados : [],
        total : [],

        anos : [],

        anoInicio : "",
        mesInicio : "",
        anoFinal : "",
        mesFinal : ""
    }),
    methods : {
        buscarPessoa: function(id){
            PessoaService.buscarPorId(id).then(response => {
                this.form = response.data.data;
            });
        },
        buscarHoras: function(){
            if(this.anoInicio > this.anoFinal){
                this.alertaErro("Ano inicial não pode ser maior que ano final!")
                return;
            }else if(this.anoInicio == this.anoFinal && this.mesInicio > this.mesFinal){
                this.alertaErro("Mês inicial não pode ser maior que o mês final!")
                return;
            }
            this.montarAnos();
            this.dados = [];
            this.$store.dispatch(START_LOADING);
            let dataInicio = `${this.anoInicio}-${this.mesInicio}-01`;
            let dataFim = `${this.anoFinal}-${this.mesFinal}-01`;
            PessoaService.equipe(dataInicio, dataFim, this.id, this.empresaSelecionada.id).then(res => {
                this.dados = res.data.data;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
                this.calcularTotal();
            });
        },
        montarAnos : function(){
            this.anos = [];            
            
            for(let i = this.anoInicio; i <= this.anoFinal; i++){
                let ano = {
                    ano: i,
                    meses: []
                };
                let mes = 1;
                if(i == this.anoInicio){
                    mes = this.mesInicio;
                }
                for(let j = mes; j <= (i == this.anoFinal ? this.mesFinal : 12); j++){
                    ano.meses.push(
                        {
                            mes : j,
                            nomeMes : helpers.retornarNomeMes(j),
                        }
                    );
                }
                this.anos.push(ano);
            }
        },
        calcularTotal : function(){
            let indice = 0;
            let meses = {
                planejado : [],
                realizado : []
            };
            for(let i = this.anoInicio; i <= this.anoFinal; i++){
                let mes = 1;
                if(i == this.anoInicio){
                    mes = this.mesInicio;
                }
                for(let j = mes; j <= (i == this.anoFinal ? this.mesFinal : 12); j++){
                    meses.planejado.push(
                        this.dados.reduce((total, info) => {
                            return total + info.alocacoes[indice].horasPrevistas;
                        }, 0)
                    );
                    meses.realizado.push(
                        this.dados.reduce((total, info) => {
                            return total + info.alocacoes[indice].horasRealizadas;
                        }, 0)
                    );
                    indice++;
                }
            }
            
            this.total = meses;
        }
    },
    mounted(){
        this.options.meses = helpers.retornarMeses();
        let ano = new Date().getFullYear();
        this.anoInicio = ano;
        this.anoFinal = ano+1;
        this.mesInicio = 1;
        this.mesFinal = 1;

        if(this.id){
            this.buscarPessoa(this.id);
            this.buscarHoras();
        }
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            { titulo: "Equipe", to: {name: "equipes"} },
            { titulo: "Horas alocadas" }
        ]);
    },
    watch : {
        'form.endereco.uf' : function(){
            InfosService.buscarCidades(this.form.endereco.uf).then(res => {
                this.options.cidades = res.data.data.map(el => {
                    return {
                        text : el.nome,
                        value : el.nome
                    }
                });
            });
        }
    },
    computed : {
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj;
        },
    
    }

    
}
</script>
<style lang="">
    
</style>